import { render, staticRenderFns } from "./FarmInfo.vue?vue&type=template&id=d9793130&scoped=true"
import script from "./FarmInfo.vue?vue&type=script&lang=ts"
export * from "./FarmInfo.vue?vue&type=script&lang=ts"
import style0 from "./FarmInfo.vue?vue&type=style&index=0&id=d9793130&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9793130",
  null
  
)

export default component.exports